import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LoadingSpinner from "../shared/LoadingSpinner/LoadingSpinner";

const isStoredProtectedPath = (path: string | null): path is string => {
	return !!path && path !== "/login" && !path.includes("login") && path !== "/index";
};

/**
 * Dedicated callback component that handles Azure AD authentication redirects.
 * This component should only be rendered at the /auth/callback route.
 */
export default function AuthRedirect() {
	const { handleAuthRedirect, consumeStoredDestination, getUser } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		const handleCallback = async () => {
			try {
				const lastVisitedPage = localStorage.getItem("lastVisitedPage");
				await handleAuthRedirect();
				if (isStoredProtectedPath(lastVisitedPage)) {
					localStorage.removeItem("lastVisitedPage");
					navigate(lastVisitedPage, { replace: true });
					return;
				}

				navigate(consumeStoredDestination(getUser()?.role), { replace: true });
			} catch (error) {
				console.error("AuthRedirect: Error handling redirect", error);
				navigate("/", { replace: true });
			}
		};

		void handleCallback();
	}, [consumeStoredDestination, getUser, handleAuthRedirect, navigate]);

	return <LoadingSpinner />;
}
